import { connect } from 'react-redux'
import {
  compose,
  withHandlers,
  lifecycle,
} from 'recompose'
import Router from 'next/router'
import {
  checkAppState
} from '../../reducers/cookies'

const mapDispatchToProps = dispatch => {
  return {
    checkAppState: () => dispatch(checkAppState())
  }
}

export default compose(
  connect(null, mapDispatchToProps),
  withHandlers({
    terminateCurrentSession: props => () => {
      props.logOut()
      Router.push('/')
    }
  }),
  lifecycle({
    componentWillMount() {
      if (this.props.isAuthenticated) {
        this.props.checkAppState()
      }
    },
    componentWillReceiveProps(nextProps) {
      if (this.props.isAuthenticated && !nextProps.isAuthenticated) {
        nextProps.terminateCurrentSession()
      }
    }
  })
)



// WEBPACK FOOTER //
// ./components/hoc/withAuthCheck.js